import { request } from '../request'

// 获取用例模板列表
interface GetTemplateListParams {
  page: number
  pageSize: number
  filterParams?: {
    name?: string
    originType?: string[]
    verificationModeIds?: number[]
    sceneIds?: number[]
    sortOrder?: 'SortOrderUnspecified' | 'SortOrderAscending' | 'SortOrderDescending'
    sortField?: 'TemplateSortFieldUpdateTime' | 'TemplateSortFieldResourceAmount'
  }
}

const getTemplateList = (params: GetTemplateListParams) =>
  request('/portal/common/resourceTemplates', {
    method: 'POST',
    data: params,
  })

// 获取模板关联/未关联用例列表
interface GetTemplateCaseListParams {
  page?: number
  pageSize?: number
  filterParams?: {
    name?: string
    originType?: string[]
    sceneId?: number[]
    verificationModeId?: number[]
    attackTypeId?: string[]
    riskLevel?: string[]
    resourceLevel?: string[]
    tagId?: string[]
    method?: string[]
    componentId?: string[]
    attckId?: string[]
    attackOrganizationId?: string[]
    sortOrder?: string
    sortField?: string
    protocol?: string[]
    attachmentType?: string[]
  }
  templateId: string[]
  queryType: 'query_bind' | 'query_unbind'
}

const getTemplateCaseList = (params: GetTemplateCaseListParams) =>
  request(`/portal/common/resourceTemplate/resources`, {
    method: 'POST',
    data: params,
  })

// 获取模板关联/未关联用例ids
const getTemplateCaseIds = (params: GetTemplateCaseListParams) =>
  request(`/portal/common/resourceTemplate/filterResourceIds`, {
    method: 'POST',
    data: params,
  })

// 添加用例模板
interface AddTemplateParams {
  name: string
  description: string
  originType: 'OriginTypeSystem' | 'OriginTypeCustom'
  verificationModeIds: number[]
  sceneIds: number[]
  resourceIds: string[]
}

const addTemplate = (params: AddTemplateParams) =>
  request('/portal/common/resourceTemplate', {
    method: 'POST',
    data: params,
    timeout: 20000,
  })

// 编辑用例模板
interface EditTemplateParams {
  templateId: string
  name: string
  description: string
  verificationModeIds: number[]
  sceneIds: number[]
  resourceIds: string[]
}

const editTemplate = (params: EditTemplateParams) =>
  request(`/portal/common/resourceTemplate/${params.templateId}`, {
    method: 'PUT',
    data: params,
  })

// 删除用例模板
const deleteTemplate = (templateIds: string[]) =>
  request(`/portal/common/resourceTemplate/batchDelete`, {
    method: 'POST',
    data: {
      templateIds,
    },
  })

// 获取用例模板详情
const getTemplateDetail = (templateId: string) =>
  request(`/portal/common/resourceTemplate/${templateId}`, {
    method: 'GET',
  })

// 获取验证模式列表
const getVerificationModeList = () =>
  request('/portal/common/verification_mode', {
    method: 'GET',
  })

// 获取攻击类型列表
const getAttackTypeList = (params: { resourceIds: string[] }) =>
  request('/portal/common/attackTypeList', {
    method: 'POST',
    data: params,
  })

// 批量解绑用例模板关联的用例
const batchUnbindTemplateCase = (templateId: string, resourceIds: string[]) =>
  request(`/portal/common/resourceTemplates/${templateId}/resources/batchUnbind`, {
    method: 'POST',
    data: {
      resourceIds,
    },
  })

// 复制模板
const copyTemplate = (templateId: string, templateName: string) =>
  request(`/portal/common/resourceTemplates/${templateId}/copy`, {
    method: 'POST',
    data: {
      templateName,
    },
    timeout: 20000,
  })

// 根据筛选条件获取模板关联/未关联用例ids
interface GetTemplateCaseIdsByFilterParams {
  templateId?: string[]
  filterParams?: {
    verificationModeId?: number[]
    sceneId?: number[]
  }
  queryType?: 'query_bind' | 'query_unbind'
}

const getTemplateCaseIdsByFilter = (params: GetTemplateCaseIdsByFilterParams) =>
  request(`/portal/common/resourceTemplate/filter/ResourceIds`, {
    method: 'POST',
    data: params,
  })

// 获取全部攻击类型
const getAllAttackTypes = (params: {
  'templateToResourceListQuery.templateId': string
  'templateToResourceListQuery.queryType': string
  'templateToResourceListQuery.verificationModeIds': number[]
}) =>
  request('/portal/common/attack/attack_type_filter_list', {
    method: 'GET',
    params: {
      queryType: 'query_type_template_to_resource_list',
      ...params,
    },
  })
export {
  getTemplateList,
  GetTemplateListParams,
  getTemplateCaseList,
  getTemplateCaseIds,
  GetTemplateCaseListParams,
  AddTemplateParams,
  addTemplate,
  EditTemplateParams,
  editTemplate,
  deleteTemplate,
  getTemplateDetail,
  getVerificationModeList,
  getAttackTypeList,
  batchUnbindTemplateCase,
  copyTemplate,
  getTemplateCaseIdsByFilter,
  GetTemplateCaseIdsByFilterParams,
  getAllAttackTypes,
}
